import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function PiCreatorInteractionDropdown(props: {
  trigger: React.ReactNode;
  items: JSX.Element[];
  label?: string;
  side?: React.ComponentProps<typeof DropdownMenu.Content>["side"];
  avoidCollisions?: boolean;
}) {
  const { trigger, items, label, side, avoidCollisions } = { ...props };
  const [width, setWidth] = useState<number>(1000);
  const ref = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (ref.current) {
      var w = ref.current?.offsetWidth.toString() + "px";
      setWidth(ref.current?.offsetWidth);
    }
  }, [ref.current?.offsetWidth]);

  return (
    <div ref={ref} className={"flex flex-col gap-[8px]"}>
      {label && (
        <div className={"font-medium text-creator-text text-[14px]"}>
          {label}
        </div>
      )}
      <DropdownMenu.Root onOpenChange={setIsOpen}>
        <DropdownMenu.Trigger
          className={
            "flex w-full bg-creator-surface rounded-full border-solid h-[38px] pl-[-0.5px] pr-[8px] py-[4px] border-[1.5px] border-interaction-primary focus:outline-none"
          }
        >
          <div
            className={
              "flex justify-start items-center w-full h-full font-medium truncate text-interaction-primary text-[14px] text-interaction"
            }
          >
            {trigger}
          </div>
          <div
            className={classNames({
              "my-auto ml-auto text-interaction-primary": true,
              "transition duration-100 ease-in-out": true,
              "transform rotate-180": isOpen,
              "transform rotate-0": !isOpen,
            })}
          >
            <ExpandMoreIcon color={"inherit"} />
          </div>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content
          style={{ width: width + "px" }}
          side={side}
          avoidCollisions={avoidCollisions}
          className={
            "flex flex-col max-h-[200px] pit-scrollbar overflow-y-auto gap-[4px] py-[10px] rounded-[5px] bg-creator-surface" +
            " border-solid" +
            " border-[1px]" +
            " border-creator-border drop-shadow-md z-40"
          }
        >
          {items.map((item, index) => {
            return (
              <DropdownMenu.Item
                key={index}
                className={
                  "cursor-pointer focus:outline-none hover:bg-creator-primary-washed"
                }
              >
                {item}
              </DropdownMenu.Item>
            );
          })}
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </div>
  );
}
